import React from 'react';
import styled from 'styled-components';
import inputValid from '../../static/img/input-valid.png';
import inputInvalid from '../../static/img/input-invalid.png';

const Wrapper = styled.fieldset`
  position: relative;
  margin: 0 0 1.2rem;
  width: 100%;

  label {
    position: absolute;
    top: -.9rem;
    display: inline-block;
    font-size: ${({ theme }) => theme.font.size.text.extrasmall};
    margin: 0 0 0 1.2rem;
    padding: 0 .5rem;
    background: #2F2F2F;
    z-index: 1;
    color: #E5E5E5;
  }

  .label-valid {
    color: #15C67D;
  }

  .label-invalid {
    color: #DE5E56;
  }

  .profile-page {
    background-color: #2F2F2F;
  }

  option {
    background: #2F2F2F;
    padding: 1.2rem 1.5rem;
  }

  .meter-unit {
    position: absolute;
    top: 1.2rem;
    right: 1rem;
  }
`

const FormField = ({ children, id, label, isValid, isInvalid }) => (
  <Wrapper className={isValid ? 'input-wrapper-valid' : isInvalid && 'input-wrapper-invalid'}>
    {label ?
      <label
        htmlFor={id}
        className={(isValid ? 'label-valid' : isInvalid && 'label-invalid') + ' profile-page'}>
        {label}
      </label>
      : null
    }
    {children}
    {isValid ?
      <img className={'input-valid-check'} src={inputValid} height={20} width={20} />
      : isInvalid &&
      <img className={'input-valid-check'} src={inputInvalid} height={20} width={20} />
    }
  </Wrapper>
)

export default FormField;